module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Tenniken-e8c7a43ce40d66dccc89104081248138.svg";